<template>
  <v-dialog
    v-model="dialog"
    width="1200"
    persistent
  >
    <v-card flat style="border-radius: 15px">
      <v-card-title>
        <v-toolbar flat class="font-weight-medium">Detail Perubahan Konfigurasi
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="black--text" style="font-size: 11pt">
        <template>
          <v-row class="mx-1" v-if="item">
            <v-col cols="12" class="text-caption">Diubah oleh <b>{{item&&item.user?item.user.nama:'?'}}</b> pada <b>{{item.created_at | toDT}}</b> WIB</v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <p class="orange--text font-weight-medium">Konfigurasi Awal</p>
              <json-viewer :expand-depth=5
                                                                copyable
                                                                boxed :value="JSON.parse(item.log_datas[0].original.konfigurasi)"></json-viewer></v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <p class="success--text font-weight-medium">Perubahan Konfigurasi</p>
              <json-viewer :expand-depth=5
                           copyable
                           boxed :value="item.parameter.konfigurasi"></json-viewer>
            </v-col>
          </v-row>
          <div class="my-4">
            <v-btn color="primary" style="border-radius: 5pt" @click="dialog=false">Tutup</v-btn>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  data() {
    return {
      dialog: false,
      item: null
    }
  },
  methods: {
    open(data) {
     this.item = data
      this.dialog = true
    },
  }
}
</script>
